if (!customElements.get('mega-nav')) {
  class MegaNav extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-mega-item]'));
      this.current = null;
      this.openTimer = null;
      this.closeTimer = null;

      this.items.forEach((item) => {
        const trigger = item.querySelector('[data-mega-trigger]');

        // Click / tap / Enter / Space toggles the panel
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          clearTimeout(this.openTimer);
          clearTimeout(this.closeTimer);
          item.classList.contains('is-open') ? this.close(item) : this.open(item);
        });

        // Mouse hover with a short intent delay (avoids flicker when passing over the bar)
        item.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse') return;
          clearTimeout(this.closeTimer);
          clearTimeout(this.openTimer);
          const delay = this.current ? 0 : 90;
          this.openTimer = setTimeout(() => this.open(item), delay);
        });

        item.addEventListener('pointerleave', (event) => {
          if (event.pointerType !== 'mouse') return;
          clearTimeout(this.openTimer);
          this.closeTimer = setTimeout(() => this.close(item), 200);
        });
      });

      // Hovering a plain link in the bar (Home, US Made) closes any open panel
      this.querySelectorAll('.mega-nav__item:not([data-mega-item])').forEach((item) => {
        item.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse') return;
          clearTimeout(this.openTimer);
          this.closeAll();
        });
      });

      this.onKeyDown = (event) => {
        if (event.key !== 'Escape' || !this.current) return;
        const trigger = this.current.querySelector('[data-mega-trigger]');
        this.close(this.current);
        trigger && trigger.focus();
      };

      this.onDocumentClick = (event) => {
        if (this.current && !this.contains(event.target)) this.closeAll();
      };

      // Keyboard: close the panel when focus moves out of it
      this.onFocusOut = () => {
        setTimeout(() => {
          if (!this.current) return;
          const focusInside = this.current.contains(document.activeElement);
          const hovered = this.current.matches(':hover');
          if (!focusInside && !hovered) this.close(this.current);
        }, 0);
      };

      this.onResize = () => this.closeAll();

      document.addEventListener('keydown', this.onKeyDown);
      document.addEventListener('click', this.onDocumentClick);
      this.addEventListener('focusout', this.onFocusOut);
      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeyDown);
      document.removeEventListener('click', this.onDocumentClick);
      this.removeEventListener('focusout', this.onFocusOut);
      window.removeEventListener('resize', this.onResize);
    }

    open(item) {
      if (this.current && this.current !== item) this.close(this.current);
      const rect = this.getBoundingClientRect();
      this.style.setProperty('--mega-nav-top', Math.max(0, Math.round(rect.bottom)) + 'px');
      item.classList.add('is-open');
      const trigger = item.querySelector('[data-mega-trigger]');
      trigger && trigger.setAttribute('aria-expanded', 'true');
      this.current = item;
    }

    close(item) {
      if (!item) return;
      item.classList.remove('is-open');
      const trigger = item.querySelector('[data-mega-trigger]');
      trigger && trigger.setAttribute('aria-expanded', 'false');
      if (this.current === item) this.current = null;
    }

    closeAll() {
      this.items.forEach((item) => this.close(item));
    }
  }

  customElements.define('mega-nav', MegaNav);
}
